<template>
  <div>
    <van-nav-bar @click-left="clickBack" title="外勤签到" left-arrow />
    <div class="form">
      <div class="wrap">
        <div class="location flex flex-b flex-vc">
          <div class="date">{{ currentTime }}</div>
          <div class="refresh">刷新地址</div>
        </div>
        <!-- <div class="location-name flex flex-vc">
          <div class="icon">
            <img src="https://profile.csdnimg.cn/F/4/E/3_yiifaa" alt="" />
          </div>
          <div class="flex-1 name"></div>
          <span class="iconfont">&#xe607;</span>
        </div> -->
        <van-cell title="齐鲁软件园A座梯型楼" icon="shop-o">
          <!-- 使用 right-icon 插槽来自定义右侧图标 -->
          <template #right-icon>
            <van-icon
              name="arrow"
              class="search=icon"
              style="font-size: 16px; line-height: inherit; color: #969799;"
            />
          </template>
        </van-cell>
        <!-- <div class="sign-type flex flex-vc flex-b">
          <div>签到类型</div>
          <div class="flex flex-vc">
            <span style="margin-right: 1rem;">早签到</span>
            <span class="iconfont">&#xe607;</span>
          </div>
        </div> -->
        <van-form>
          <van-field
            v-model="form.matter"
            label="请假事项"
            placeholder="点击选择"
            clickable
            readonly
            required
            is-link
            size="large"
            @click="showPicker = true"
          />
          <van-field name="uploader" label="拍照" size="large" required center>
            <template #input>
              <van-uploader
                v-model="curFileList"
                :after-read="afterReadCur"
                :before-delete="beforeDelCur"
                :max-count="1"
                multiple
                capture="camera"
              >
                <!-- <img
                src="../assets/images/avatar.png"
                alt=""
                style="width: 2.75rem; height: 2.75rem;"
              /> -->
              </van-uploader>
            </template>
          </van-field>
          <van-field
            type="textarea"
            placeholder="请输入备注"
            label="备注"
            v-model="form.remark"
            size="large"
          />
          <div style="margin: 26px;">
            <van-button round block type="info" native-type="submit">
              提交
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        title="事项"
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { getDateYMD } from '@/utils/'
export default {
  data() {
    return {
      form: {},
      showPicker: false,
      columns: ['早签到', '晚签到'],
      curFileList: [],
    }
  },
  computed: {
    currentTime() {
      return getDateYMD(new Date())
    },
  },
  methods: {
    clickBack() {
      this.$router.go(-1)
    },
    onConfirm(value, index) {
      this.$set(this.form, 'matter', value)
      this.showPicker = false
      this.$toast(`当前值：${value}, 当前索引：${index}`)
    },
    afterReadCur() {},
    beforeDelCur() {},
  },
}
</script>

<style lang="scss" scoped>
.form {
  margin: 1rem;
  .wrap {
    border-radius: 0.75rem;
    overflow: hidden;
    /* box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.03); */
  }
  .location {
    background: #fff;
    padding: 0.8rem 0.75rem;
    .date {
      color: #999;
      font-size: 0.75rem;
    }
    .refresh {
      font-size: 0.85rem;
      color: #78849e;
    }
  }
  .location-name {
    padding: 1.3rem 0.75rem;
    background: #fff;
    border-top: 1px solid #f4f4f6;
    .name {
      margin-left: 1rem;
      color: #333;
    }
    .icon {
      width: 2rem;
      height: 2rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .sign-type {
    border-top: 1px solid #f4f4f6;

    padding: 0.8rem 0.75rem;
    background: #fff;
    font-size: 0.85rem;
  }
}
</style>
